var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLower({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.42 103.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #039;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #00cc87;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.11,0H22.51c-2.37,0-4.31,1.93-4.31,4.31v55.8h19.73c2.97,0,5.39,2.42,5.39,5.39v19.73h55.8c2.37,0,4.31-1.93,4.31-4.31V4.31C103.42,1.93,101.49,0,99.11,0h0ZM72.93,17.47c-1.78.01-3.23-1.42-3.24-3.19-.01-1.78,1.42-3.23,3.19-3.24l16.33-.19c1.78-.01,3.23,1.42,3.24,3.19l.19,16.33c.01,1.78-1.42,3.23-3.19,3.24-1.78.01-3.23-1.42-3.24-3.19l-.1-8.57-34.37,34.37c-1.26,1.26-3.31,1.26-4.57,0s-1.26-3.31,0-4.57l34.27-34.27-8.51.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,65.49v34.7c0,1.78,1.45,3.23,3.23,3.23h34.7c1.78,0,3.23-1.45,3.23-3.23v-34.7c0-1.78-1.45-3.23-3.23-3.23H3.23c-1.78,0-3.23,1.45-3.23,3.23h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLower);
export default __webpack_public_path__ + "static/media/lower.b8b9ce0b2711d3f396a3cf94e861e726.svg";
export { ForwardRef as ReactComponent };